module.exports = __webpack_public_path__ + "static/media/image19.15778259.png";